import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '../../common-app/services/window';
import { EnviromentContextService } from '../../enviroment/services/enviroment-context-service';


@Injectable()
export class ComposeUrlService {

  constructor(
    private enviromentContextService: EnviromentContextService,
    @Inject(WINDOW) private window: Window
  ) { }

  public composeUrl(endpoint: string): string {
    const company = this.enviromentContextService.getCompany();
    return `ODataV4/${endpoint}?Company=${company}`;
  }

  public composeToolsUrl(endpoint: string): string {
    switch (this.window.location.hostname) {
      case 'localhost':
      case 'local.cosmos.omni':
        return `http://localhost:7071/api/${endpoint}`;
      case 'local.cosmosomni.com':
        return `https://cosmos-sga-dev-f0b8hxc7fdeafpbx.spaincentral-01.azurewebsites.net/api/${endpoint}`;
      case 'test.cosmosomni.com':
        return `https://cosmos-sga-dev-f0b8hxc7fdeafpbx.spaincentral-01.azurewebsites.net/api/${endpoint}`;
      case 'brownie.cosmosomni.com':
      case 'witty-ocean-02f42d003-releasecandidate.westeurope.5.azurestaticapps.net':
        return `https://cosmos-sga-prod-hee6c3gtg5gmdfc3.spaincentral-01.azurewebsites.net/api/${endpoint}`;
      default:
        return '';
    }
  }
}
